import { render, staticRenderFns } from "./YtMultiSelect.vue?vue&type=template&id=b5c3ea4c&scoped=true&"
import script from "./YtMultiSelect.vue?vue&type=script&lang=js&"
export * from "./YtMultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c3ea4c",
  null
  
)

export default component.exports